// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: 'payroll-adjustments/archive',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-payroll-adjustments" */ '@/pages/[organisation]/hr/team-member-payroll-adjustments/archived-team-member-payroll-adjustments.vue'),
        name: 'human-resource.team-member-payroll-adjustments.archived-team-member-payroll-adjustments',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.payroll.update-team-member-payroll-adjustment',
        },
    },
    {
        path: 'payroll-adjustments/archive/:adjustmentId',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-payroll-adjustments" */ '@/pages/[organisation]/hr/team-member-payroll-adjustments/archived-team-member-payroll-adjustment/[id].vue'),
        name: 'human-resource.team-member-payroll-adjustments.view-archived-team-member-payroll-adjustment',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.payroll.update-team-member-payroll-adjustment',
        },
    },

    {
        path: 'payroll-adjustments',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-payroll-adjustments" */ '@/pages/[organisation]/hr/team-member-payroll-adjustments/team-member-payroll-adjustments.vue'),
        name: 'human-resource.team-member-payroll-adjustments.search-team-member-payroll-adjustments',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.payroll.view-team-member-payroll-adjustments',
        },
    },
    {
        path: 'payroll-adjustments/new',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-payroll-adjustments" */ '@/pages/[organisation]/hr/team-member-payroll-adjustments/team-member-payroll-adjustment/new.vue'),
        name: 'human-resource.team-member-payroll-adjustments.create-team-member-payroll-adjustment',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.payroll.create-team-member-payroll-adjustment',
        },
    },
    {
        path: 'payroll-adjustments/:adjustmentId',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-payroll-adjustments" */ '@/pages/[organisation]/hr/team-member-payroll-adjustments/team-member-payroll-adjustment/[id].vue'),
        name: 'human-resource.team-member-payroll-adjustments.view-team-member-payroll-adjustment',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.payroll.view-team-member-payroll-adjustments',
        },
    },
    {
        path: 'payroll-adjustments/:adjustmentId/edit',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-payroll-adjustments" */ '@/pages/[organisation]/hr/team-member-payroll-adjustments/team-member-payroll-adjustment/[id]/edit.vue'),
        name: 'human-resource.team-member-payroll-adjustments.update-team-member-payroll-adjustment',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.payroll.update-team-member-payroll-adjustment',
        },
    },
];
